/* centauri-c25-wave-theme.js
   Recolours the UNPLAYED waveform bars of the Centauri C25 switch-audio players
   to the design colour #66737f.

   Why this file exists (escape-hatch note):
   - The players are wired by the frozen assets/kikstart-custom.js, which creates
     WaveSurfer with a HARDCODED waveColor:"#ffffff" (unplayed bars). Only the
     played colour (progressColor) is themeable via --audio-wave-color.
   - WaveSurfer v7 renders inside an open shadow root (attachShadow({mode:"open"}))
     with NO part attributes, so outer CSS cannot reach the bars. The base
     (unplayed) canvases live under `.canvases`; the played overlay lives under
     the sibling `.progress`, so filtering `.canvases` only retints unplayed bars.
   - The filter chain below maps #ffffff -> #66737f exactly. Calibrated by pixel
     sampling in headless Chromium: rendered result rgb(102,115,127), deltaE 0.00
     against the target (CIE76). It is background-independent and preserves the
     bars' antialiased alpha.

   Safety:
   - IIFE + window guard: idempotent if the delay-JS rescue loader executes it twice.
   - Scoped to [data-centauri-switch-audio] roots only; multi-instance safe.
   - MutationObserver fallback: WaveSurfer may initialise long after this script
     (the store's delay-JS defers kikstart-custom.js), so each waveform container
     is watched until its shadow host appears.
   - Theme Editor safe: re-scans on shopify:section:load; per-element flags keep
     re-runs cheap and duplicate-free.
*/
(function () {
  'use strict';

  if (window.__centauriC25WaveTheme) return;
  window.__centauriC25WaveTheme = true;

  var STYLE_FLAG = 'data-centauri-c25-wave-theme';
  /* #ffffff -> #66737f (unplayed bars). Calibrated: deltaE 0.00 in Chromium. */
  var UNPLAYED_FILTER =
    'brightness(0) invert(47%) sepia(85%) saturate(2027%) hue-rotate(188deg) brightness(49%) contrast(24%)';

  function themeShadow(host) {
    var root = host && host.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('style[' + STYLE_FLAG + ']')) {
      var style = document.createElement('style');
      style.setAttribute(STYLE_FLAG, 'true');
      style.textContent = '.canvases{filter:' + UNPLAYED_FILTER + ';}';
      root.appendChild(style);
    }
    return true;
  }

  /* WaveSurfer appends one shadow-host div into the #waveform-* container. */
  function themeWaveform(waveEl) {
    if (waveEl.getAttribute(STYLE_FLAG) === 'done') return true;
    var done = false;
    for (var i = 0; i < waveEl.children.length; i += 1) {
      if (themeShadow(waveEl.children[i])) done = true;
    }
    if (done) waveEl.setAttribute(STYLE_FLAG, 'done');
    return done;
  }

  function watchWaveform(waveEl) {
    if (themeWaveform(waveEl)) return;
    if (waveEl.getAttribute(STYLE_FLAG) === 'watching') return;
    waveEl.setAttribute(STYLE_FLAG, 'watching');
    var observer = new MutationObserver(function () {
      if (themeWaveform(waveEl)) observer.disconnect();
    });
    observer.observe(waveEl, { childList: true });
  }

  function scan(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll('[data-centauri-switch-audio]');
    for (var i = 0; i < roots.length; i += 1) {
      var waves = roots[i].querySelectorAll('.audio-player [id^="waveform-"]');
      for (var j = 0; j < waves.length; j += 1) watchWaveform(waves[j]);
    }
  }

  function init() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan((event && event.target) || document);
  });
})();
